import { EmrNotificationApiDto } from "@/model/Patient"
import { DayOfWeek, Instant, LocalDate, ZoneId } from "@js-joda/core"

/**
 * Generate all dates for a calendar grid including leading/trailing days from adjacent months
 * to fill complete weeks. The grid will always start on Sunday.
 */

// TODO: Do we want to start on monday?
export const generateMonthDates = (
  year: number,
  month: number
): LocalDate[] => {
  const firstDayOfMonth = LocalDate.of(year, month, 1)
  const lastDayOfMonth = firstDayOfMonth.plusMonths(1).minusDays(1)

  const startDate =
    firstDayOfMonth.dayOfWeek() === DayOfWeek.SUNDAY
      ? firstDayOfMonth
      : firstDayOfMonth.minusDays(firstDayOfMonth.dayOfWeek().value() % 7)

  const daysUntilSaturday =
    (DayOfWeek.SATURDAY.value() - lastDayOfMonth.dayOfWeek().value() + 7) % 7
  const endDate = lastDayOfMonth.plusDays(daysUntilSaturday)

  const dates: LocalDate[] = []
  let currentDate = startDate

  while (!currentDate.isAfter(endDate)) {
    dates.push(currentDate)
    currentDate = currentDate.plusDays(1)
  }

  return dates
}

/**
 * Group notifications by their date in the specified timezone
 */
export const groupNotificationsByDate = (
  notifications: EmrNotificationApiDto[],
  timeZone: string
): Map<string, EmrNotificationApiDto[]> => {
  const grouped = new Map<string, EmrNotificationApiDto[]>()

  notifications.forEach((notification) => {
    // Use sentAt if available,
    // otherwise use enqueuedAt so we can show them in the same cell
    const timestamp = notification.sentAt
      ? Instant.parse(notification.sentAt)
      : Instant.parse(notification.enqueuedAt)
    const date = timestamp.atZone(ZoneId.of(timeZone)).toLocalDate()
    const dateKey = date.toString()

    if (!grouped.has(dateKey)) {
      grouped.set(dateKey, [])
    }
    grouped.get(dateKey)!.push(notification)
  })

  return grouped
}

/**
 * Check if a date is today
 */
export const isToday = (date: LocalDate): boolean => {
  const today = LocalDate.now()
  return date.equals(today)
}
